import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";

import { DummyWidgetComponentController } from "./DummyWidgetComponentController";

export class DummyWidgetComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {};
        this.controller = DummyWidgetComponentController;
        this.templateUrl = "/App/Modules/Gui/Components/Widgets/Widget.html";
    }
}
